import css from "./LevelSA.module.css";

export function LevelSA(params: { value: number | null }) {
  const { value } = params;
  return value ? <div className={css.root}>{value}</div> : null;
}
